// Make them as label and value object
export const SESSIONS_STATUS = (t: any) => [
  {
    label: t('sessions.status.Pending'),
    value: 'Pending',
  },
  {
    label: t('sessions.status.Live'),
    value: 'Live',
  },
  {
    label: t('sessions.status.Expired'),
    value: 'Expired',
  },
]
